/** Shown while a listing reloads after a filter change. */
export default function Loader() {
  return (
    <div className="flex justify-center py-6" role="status">
      <span className="sr-only">Loading tutorials</span>
      <span className="size-9 animate-spin rounded-full border-4 border-qt-soft border-t-qt-primary" aria-hidden="true" />
    </div>
  )
}
